import auth from './auth';

// Senha do painel lembrada neste navegador, para não pedir a cada abertura.
const CHAVE = 'lukos-senha-painel';

export function lerSenhaSalva() {
    try {
        return localStorage.getItem(CHAVE);
    } catch (e) {
        return null;
    }
}

export function salvarSenha(senha) {
    try {
        localStorage.setItem(CHAVE, senha);
    } catch (e) {
        // navegador sem localStorage: só não lembra
    }
}

export function esquecerSenha() {
    try {
        localStorage.removeItem(CHAVE);
    } catch (e) {
        // nada a fazer
    }
}

// Valida sem alerta nem redirecionamento, para testar a senha salva em silêncio.
// true = senha certa; false = senha recusada (a API responde 201 ou 4xx);
// null = sem conexão ou servidor com erro, quando não dá para saber se a senha vale.
export async function validarSenha(senha) {
    try {
        const response = await auth.get('lukos/ValidaSenhahoje', {
            headers: { snha: senha }
        });
        return response.status === 200;
    } catch (error) {
        const status = error.response && error.response.status;
        return status >= 400 && status < 500 ? false : null;
    }
}
